import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IrbOptionChains } from "@irb/irb-option-chains/irb-option-chains.model";

@Component({ standalone: false,
    selector: 'option-chains-dialog',
    templateUrl: './option-chains-dialog.component.html',
    styleUrls: ['./option-chains-dialog.component.scss']
})
export class OptionChainsDialog implements OnInit, OnDestroy {

    selectOptionsFunction: Function;

    _optionChainInput: IrbOptionChains;
    
    constructor(public dialogRef: MatDialogRef<OptionChainsDialog>,
        @Inject(MAT_DIALOG_DATA) public mdd: any) {
    }

    ngOnInit(): void {
        this.optionChainInput = {
            underlyingSymbol: this.mdd.data.underlyingSymbol,
            selectedOptions: this.mdd.data.selectedOptions,
            chainType: this.mdd.data.chainType,
            isChainTypeDisable: this.mdd.data.isChainTypeDisable,
            isTrayVisible: (this.mdd.data.isTrayVisible !== null && this.mdd.data.isTrayVisible !== undefined) ? this.mdd.data.isTrayVisible : true
        } as IrbOptionChains;
        if (this.optionChainInput.underlyingSymbol !== null && this.optionChainInput.underlyingSymbol !== undefined) {
            this.optionChainInput.isUnderlyingSymbolDiable = true;
        }
        this.populateCCTradeTypeData(this.mdd.data.action);
    }

    ngOnDestroy(): void {
    }

    close() {
        this.dialogRef.close();
        this._optionChainInput = null;
    }

    populateCCTradeTypeData(action: string) {
        switch(action) {
            case 'SELL_COVER_CALL':
                this.optionChainInput.chainType = 'CALL';
                this.optionChainInput.isChainTypeDisable = true;
                break;
            case 'BUY_TO_COVER':
                this.optionChainInput.isUnderlyingSymbolDiable = true;
                break;
            case 'PURCHASE_UNDERLYING_SELL_COVER_CALL':
                this.optionChainInput.chainType = 'CALL';
                this.optionChainInput.isChainTypeDisable = true;
                break;
            case 'ROLL_COVER_CALL':
                this.optionChainInput.isUnderlyingSymbolDiable = true;
                break;
        }
    }

    get optionChainInput() {
        return this._optionChainInput;
    }

    set optionChainInput(optionChainInput: IrbOptionChains) {
        this._optionChainInput = optionChainInput;
    }
    
}
